/** @jsx jsx */
// @ts-check
/**
 * Customizations:
 * - Increased header height to 96.
 * - Changed shadow.
 */

import BaseHeader from '@bottlebooks/gatsby-theme-event/src/components/Layout/Header';
import { jsx } from 'theme-ui';

export default function Header(props) {
  return (
    <BaseHeader
      sx={{
        height: [48, 96],
        boxShadow: 'header',
        transform: props.showHeader
          ? undefined
          : [undefined, `translateY(-96px)`],
      }}
      {...props}
    />
  );
}
